import React from "react";
import { ButtonBase, Typography, makeStyles } from "@material-ui/core";
import { OpenInNew, RoomOutlined } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    maxWidth: 320,
  },

  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 14,
    textAlign: "left",
    backgroundColor: theme.mode === "light" ? "#f8f9fb" : "#1f2c33",
    border: `1px solid ${theme.mode === "light" ? "#dde3ea" : "#23323a"}`,
  },

  imageWrap: {
    position: "relative",
    width: "100%",
    height: 168,
    background:
      "linear-gradient(135deg, rgba(86,124,255,0.22), rgba(43,183,120,0.18))",
  },

  imageFallback: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.mode === "light" ? "#335c7d" : "#d7e8f4",
    background:
      "linear-gradient(135deg, rgba(86,124,255,0.22), rgba(43,183,120,0.18))",
  },

  badge: {
    position: "absolute",
    left: 12,
    top: 12,
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 10px",
    borderRadius: 999,
    color: "#fff",
    backgroundColor: "rgba(20, 27, 34, 0.62)",
    backdropFilter: "blur(6px)",
    fontSize: 12,
    fontWeight: 600,
  },

  content: {
    padding: "12px 14px 14px",
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },

  title: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.mode === "light" ? "#122433" : "#f2f7fb",
  },

  description: {
    fontSize: 13,
    lineHeight: 1.45,
    color: theme.mode === "light" ? "#506070" : "#c5d4df",
    wordBreak: "break-word",
  },

  footer: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    marginTop: 4,
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.primary.main,
  },

  compactRoot: {
    width: "100%",
    maxWidth: 280,
  },

  compactCard: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: 10,
    borderRadius: 12,
    textAlign: "left",
    backgroundColor: theme.mode === "light" ? "#f8f9fb" : "#1f2c33",
    border: `1px solid ${theme.mode === "light" ? "#dde3ea" : "#23323a"}`,
  },

  compactText: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },

  compactTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: theme.mode === "light" ? "#122433" : "#f2f7fb",
  },

  compactDescription: {
    fontSize: 12,
    color: theme.mode === "light" ? "#506070" : "#c5d4df",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    wordBreak: "break-word",
  },
}));

const LocationPreview = ({ link, description, compact = false }) => {
  const classes = useStyles();
  const safeDescription = (description || "").replace(/\\n/g, "\n");

  if (compact) {
    return (
      <ButtonBase
        className={classes.compactRoot}
        component="a"
        href={link || "#"}
        target="_blank"
        rel="noopener noreferrer"
        disabled={!link}
      >
        <div className={classes.compactCard}>
          <div
            className={classes.imageFallback}
            style={{
              width: 72,
              minWidth: 72,
              height: 72,
              borderRadius: 12,
            }}
          >
            <RoomOutlined style={{ fontSize: 28 }} />
          </div>

          <div className={classes.compactText}>
            <Typography className={classes.compactTitle}>Localizacao</Typography>
            <Typography className={classes.compactDescription}>
              {safeDescription || "Abrir no mapa"}
            </Typography>
          </div>
        </div>
      </ButtonBase>
    );
  }

  return (
    <ButtonBase
      className={classes.root}
      component="a"
      href={link || "#"}
      target="_blank"
      rel="noopener noreferrer"
      disabled={!link}
    >
      <div className={classes.card}>
        <div className={classes.imageWrap}>
          <div className={classes.imageFallback}>
            <RoomOutlined style={{ fontSize: 40 }} />
          </div>
          <div className={classes.badge}>
            <RoomOutlined style={{ fontSize: 16 }} />
            <span>Localizacao</span>
          </div>
        </div>

        <div className={classes.content}>
          <Typography className={classes.title}>Localizacao compartilhada</Typography>
          {safeDescription ? (
            <Typography className={classes.description}>
              {safeDescription}
            </Typography>
          ) : null}

          <div className={classes.footer}>
            <OpenInNew style={{ fontSize: 16 }} />
            <span>Abrir no mapa</span>
          </div>
        </div>
      </div>
    </ButtonBase>
  );
};

export default LocationPreview;
